import React, { useEffect, useMemo, useState } from "react";
import { COMPONENT_OUTLINE_BORDER } from "../theme/componentBorders";
import {
  Button,
  Modal,
  Card,
  Typography,
  Input,
  Space,
  Collapse,
  Empty,
} from "antd";
import {
  SettingOutlined,
  HomeOutlined,
  CloudOutlined,
  FileTextOutlined,
  MonitorOutlined,
  ApiOutlined,
  UserOutlined,
  DatabaseOutlined,
  AppstoreOutlined,
  TeamOutlined,
  ShoppingCartOutlined,
  BarChartOutlined,
  MailOutlined,
  PhoneOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  EnvironmentOutlined,
  HeartOutlined,
  StarOutlined,
  LikeOutlined,
  MessageOutlined,
  BellOutlined,
  SearchOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  CloseOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
  WarningOutlined,
  LockOutlined,
  UnlockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  DownloadOutlined,
  UploadOutlined,
  ShareAltOutlined,
  LinkOutlined,
  GlobalOutlined,
  WifiOutlined,
  MobileOutlined,
  DesktopOutlined,
  LaptopOutlined,
  TabletOutlined,
  CameraOutlined,
  PictureOutlined,
  VideoCameraOutlined,
  SoundOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
  StopOutlined,
  ReloadOutlined,
  SyncOutlined,
  LoadingOutlined,
  ThunderboltOutlined,
  FireOutlined,
  BugOutlined,
  ToolOutlined,
  SafetyOutlined,
  SecurityScanOutlined,
  KeyOutlined,
  TagsOutlined,
  TagOutlined,
  FlagOutlined,
  BookOutlined,
  FileOutlined,
  FolderOutlined,
  FolderOpenOutlined,
  InboxOutlined,
  SendOutlined,
  PrinterOutlined,
  ScanOutlined,
  QrcodeOutlined,
  CalculatorOutlined,
  FundOutlined,
  DollarOutlined,
  WalletOutlined,
  BankOutlined,
  CreditCardOutlined,
  PayCircleOutlined,
  ShopOutlined,
  GiftOutlined,
  TrophyOutlined,
  CrownOutlined,
  RocketOutlined,
  CarOutlined,
  TruckOutlined,
  BulbOutlined,
  AreaChartOutlined,
  PieChartOutlined,
  DotChartOutlined,
  LineChartOutlined,
  RadarChartOutlined,
  HeatMapOutlined,
  FallOutlined,
  RiseOutlined,
  StockOutlined,
  BoxPlotOutlined,
  AccountBookOutlined,
  AimOutlined,
  AlertOutlined,
  ApartmentOutlined,
  AppstoreAddOutlined,
  AudioOutlined,
  AudioMutedOutlined,
  AuditOutlined,
  BarcodeOutlined,
  BarsOutlined,
  BlockOutlined,
  BorderlessTableOutlined,
  BranchesOutlined,
  BuildOutlined,
  CarryOutOutlined,
  CiCircleOutlined,
  CiOutlined,
  ClearOutlined,
  CommentOutlined,
  CompassOutlined,
  CompressOutlined,
  ConsoleSqlOutlined,
  ContactsOutlined,
  ContainerOutlined,
  ControlOutlined,
  CopyrightOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DeploymentUnitOutlined,
  DisconnectOutlined,
  EllipsisOutlined,
  EuroCircleOutlined,
  ExceptionOutlined,
  ExpandAltOutlined,
  ExpandOutlined,
  ExperimentOutlined,
  ExportOutlined,
  FileAddOutlined,
  FileDoneOutlined,
  FileExcelOutlined,
  FileGifOutlined,
  FileImageOutlined,
  FileJpgOutlined,
  FileMarkdownOutlined,
  FilePdfOutlined,
  FileProtectOutlined,
  FilePptOutlined,
  FileSearchOutlined,
  FileSyncOutlined,
  FileUnknownOutlined,
  FileWordOutlined,
  FileZipOutlined,
  FilterOutlined,
  FolderAddOutlined,
  FolderViewOutlined,
  FunnelPlotOutlined,
  GatewayOutlined,
  GifOutlined,
  GoldOutlined,
  GroupOutlined,
  HddOutlined,
  HistoryOutlined,
  HourglassOutlined,
  IdcardOutlined,
  ImportOutlined,
  InsertRowAboveOutlined,
  InsertRowBelowOutlined,
  InsertRowLeftOutlined,
  InsertRowRightOutlined,
  InsuranceOutlined,
  InteractionOutlined,
  LayoutOutlined,
  LineOutlined,
  Loading3QuartersOutlined,
  MacCommandOutlined,
  ManOutlined,
  MedicineBoxOutlined,
  MenuOutlined,
  MergeCellsOutlined,
  MoneyCollectOutlined,
  MoreOutlined,
  NodeExpandOutlined,
  NodeIndexOutlined,
  NotificationOutlined,
  NumberOutlined,
  OneToOneOutlined,
  PaperClipOutlined,
  PartitionOutlined,
  PercentageOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

type IconOption = {
  name: string;
  component: React.ComponentType<{ style?: React.CSSProperties }>;
  label: string;
};

type IconCategory = {
  key: string;
  title: string;
  icons: IconOption[];
};

// 图标配置
export const iconCategories: IconCategory[] = [
  {
    key: "common",
    title: "常用",
    icons: [
      { name: "setting", component: SettingOutlined, label: "设置" },
      { name: "home", component: HomeOutlined, label: "首页" },
      { name: "user", component: UserOutlined, label: "用户" },
      { name: "team", component: TeamOutlined, label: "团队" },
      { name: "appstore", component: AppstoreOutlined, label: "应用商店" },
      { name: "api", component: ApiOutlined, label: "API" },
      { name: "database", component: DatabaseOutlined, label: "数据库" },
      { name: "cloud", component: CloudOutlined, label: "云服务" },
      { name: "monitor", component: MonitorOutlined, label: "监控" },
      { name: "file-text", component: FileTextOutlined, label: "文档" },
      {
        name: "shopping-cart",
        component: ShoppingCartOutlined,
        label: "购物车",
      },
      { name: "bar-chart", component: BarChartOutlined, label: "图表" },
      { name: "search", component: SearchOutlined, label: "搜索" },
      { name: "plus", component: PlusOutlined, label: "添加" },
      { name: "check", component: CheckOutlined, label: "确认" },
      { name: "close", component: CloseOutlined, label: "关闭" },
    ],
  },
  {
    key: "data",
    title: "数据图标",
    icons: [
      {
        name: "area-chart",
        component: AreaChartOutlined,
        label: "AreaChartOutlined",
      },
      {
        name: "pie-chart",
        component: PieChartOutlined,
        label: "PieChartOutlined",
      },
      {
        name: "bar-chart-data",
        component: BarChartOutlined,
        label: "BarChartOutlined",
      },
      {
        name: "dot-chart",
        component: DotChartOutlined,
        label: "DotChartOutlined",
      },
      {
        name: "line-chart",
        component: LineChartOutlined,
        label: "LineChartOutlined",
      },
      {
        name: "radar-chart",
        component: RadarChartOutlined,
        label: "RadarChartOutlined",
      },
      {
        name: "heat-map",
        component: HeatMapOutlined,
        label: "HeatMapOutlined",
      },
      { name: "fall", component: FallOutlined, label: "FallOutlined" },
      { name: "rise", component: RiseOutlined, label: "RiseOutlined" },
      { name: "stock", component: StockOutlined, label: "StockOutlined" },
      {
        name: "box-plot",
        component: BoxPlotOutlined,
        label: "BoxPlotOutlined",
      },
      { name: "fund-data", component: FundOutlined, label: "FundOutlined" },
    ],
  },
  {
    key: "web-general",
    title: "网站通用类图标",
    icons: [
      {
        name: "account-book",
        component: AccountBookOutlined,
        label: "AccountBookOutlined",
      },
      { name: "aim", component: AimOutlined, label: "AimOutlined" },
      { name: "alert", component: AlertOutlined, label: "AlertOutlined" },
      {
        name: "apartment",
        component: ApartmentOutlined,
        label: "ApartmentOutlined",
      },
      {
        name: "appstore-add",
        component: AppstoreAddOutlined,
        label: "AppstoreAddOutlined",
      },
      { name: "audio", component: AudioOutlined, label: "AudioOutlined" },
      {
        name: "audio-muted",
        component: AudioMutedOutlined,
        label: "AudioMutedOutlined",
      },
      { name: "audit", component: AuditOutlined, label: "AuditOutlined" },
      { name: "barcode", component: BarcodeOutlined, label: "BarcodeOutlined" },
      { name: "bars", component: BarsOutlined, label: "BarsOutlined" },
      { name: "block", component: BlockOutlined, label: "BlockOutlined" },
      {
        name: "borderless-table",
        component: BorderlessTableOutlined,
        label: "BorderlessTableOutlined",
      },
      {
        name: "branches",
        component: BranchesOutlined,
        label: "BranchesOutlined",
      },
      { name: "build", component: BuildOutlined, label: "BuildOutlined" },
      {
        name: "carry-out",
        component: CarryOutOutlined,
        label: "CarryOutOutlined",
      },
      { name: "ci", component: CiOutlined, label: "CiOutlined" },
      {
        name: "ci-circle",
        component: CiCircleOutlined,
        label: "CiCircleOutlined",
      },
      { name: "clear", component: ClearOutlined, label: "ClearOutlined" },
      { name: "comment", component: CommentOutlined, label: "CommentOutlined" },
      { name: "compass", component: CompassOutlined, label: "CompassOutlined" },
      {
        name: "compress",
        component: CompressOutlined,
        label: "CompressOutlined",
      },
      {
        name: "console-sql",
        component: ConsoleSqlOutlined,
        label: "ConsoleSqlOutlined",
      },
      {
        name: "contacts",
        component: ContactsOutlined,
        label: "ContactsOutlined",
      },
      {
        name: "container",
        component: ContainerOutlined,
        label: "ContainerOutlined",
      },
      { name: "control", component: ControlOutlined, label: "ControlOutlined" },
      {
        name: "copyright",
        component: CopyrightOutlined,
        label: "CopyrightOutlined",
      },
      {
        name: "customer-service",
        component: CustomerServiceOutlined,
        label: "CustomerServiceOutlined",
      },
      {
        name: "dashboard",
        component: DashboardOutlined,
        label: "DashboardOutlined",
      },
      {
        name: "deployment-unit",
        component: DeploymentUnitOutlined,
        label: "DeploymentUnitOutlined",
      },
      {
        name: "disconnect",
        component: DisconnectOutlined,
        label: "DisconnectOutlined",
      },
      {
        name: "ellipsis",
        component: EllipsisOutlined,
        label: "EllipsisOutlined",
      },
      {
        name: "euro-circle",
        component: EuroCircleOutlined,
        label: "EuroCircleOutlined",
      },
      {
        name: "exception",
        component: ExceptionOutlined,
        label: "ExceptionOutlined",
      },
      { name: "expand", component: ExpandOutlined, label: "ExpandOutlined" },
      {
        name: "expand-alt",
        component: ExpandAltOutlined,
        label: "ExpandAltOutlined",
      },
      {
        name: "experiment",
        component: ExperimentOutlined,
        label: "ExperimentOutlined",
      },
      { name: "export", component: ExportOutlined, label: "ExportOutlined" },
      {
        name: "file-add",
        component: FileAddOutlined,
        label: "FileAddOutlined",
      },
      {
        name: "file-done",
        component: FileDoneOutlined,
        label: "FileDoneOutlined",
      },
      {
        name: "file-excel",
        component: FileExcelOutlined,
        label: "FileExcelOutlined",
      },
      {
        name: "file-gif",
        component: FileGifOutlined,
        label: "FileGifOutlined",
      },
      {
        name: "file-image",
        component: FileImageOutlined,
        label: "FileImageOutlined",
      },
      {
        name: "file-jpg",
        component: FileJpgOutlined,
        label: "FileJpgOutlined",
      },
      {
        name: "file-markdown",
        component: FileMarkdownOutlined,
        label: "FileMarkdownOutlined",
      },
      {
        name: "file-pdf",
        component: FilePdfOutlined,
        label: "FilePdfOutlined",
      },
      {
        name: "file-protect",
        component: FileProtectOutlined,
        label: "FileProtectOutlined",
      },
      {
        name: "file-ppt",
        component: FilePptOutlined,
        label: "FilePptOutlined",
      },
      {
        name: "file-search",
        component: FileSearchOutlined,
        label: "FileSearchOutlined",
      },
      {
        name: "file-sync",
        component: FileSyncOutlined,
        label: "FileSyncOutlined",
      },
      {
        name: "file-unknown",
        component: FileUnknownOutlined,
        label: "FileUnknownOutlined",
      },
      {
        name: "file-word",
        component: FileWordOutlined,
        label: "FileWordOutlined",
      },
      {
        name: "file-zip",
        component: FileZipOutlined,
        label: "FileZipOutlined",
      },
      { name: "filter", component: FilterOutlined, label: "FilterOutlined" },
      {
        name: "folder-add",
        component: FolderAddOutlined,
        label: "FolderAddOutlined",
      },
      {
        name: "folder-view",
        component: FolderViewOutlined,
        label: "FolderViewOutlined",
      },
      {
        name: "funnel-plot",
        component: FunnelPlotOutlined,
        label: "FunnelPlotOutlined",
      },
      { name: "gateway", component: GatewayOutlined, label: "GatewayOutlined" },
      { name: "gif", component: GifOutlined, label: "GifOutlined" },
      { name: "gold", component: GoldOutlined, label: "GoldOutlined" },
      { name: "group", component: GroupOutlined, label: "GroupOutlined" },
      { name: "hdd", component: HddOutlined, label: "HddOutlined" },
      { name: "history", component: HistoryOutlined, label: "HistoryOutlined" },
      {
        name: "hourglass",
        component: HourglassOutlined,
        label: "HourglassOutlined",
      },
      { name: "idcard", component: IdcardOutlined, label: "IdcardOutlined" },
      { name: "import", component: ImportOutlined, label: "ImportOutlined" },
      {
        name: "insert-row-above",
        component: InsertRowAboveOutlined,
        label: "InsertRowAboveOutlined",
      },
      {
        name: "insert-row-below",
        component: InsertRowBelowOutlined,
        label: "InsertRowBelowOutlined",
      },
      {
        name: "insert-row-left",
        component: InsertRowLeftOutlined,
        label: "InsertRowLeftOutlined",
      },
      {
        name: "insert-row-right",
        component: InsertRowRightOutlined,
        label: "InsertRowRightOutlined",
      },
      {
        name: "insurance",
        component: InsuranceOutlined,
        label: "InsuranceOutlined",
      },
      {
        name: "interaction",
        component: InteractionOutlined,
        label: "InteractionOutlined",
      },
      { name: "layout", component: LayoutOutlined, label: "LayoutOutlined" },
      { name: "line", component: LineOutlined, label: "LineOutlined" },
      {
        name: "loading-3-quarters",
        component: Loading3QuartersOutlined,
        label: "Loading3QuartersOutlined",
      },
      {
        name: "mac-command",
        component: MacCommandOutlined,
        label: "MacCommandOutlined",
      },
      { name: "man", component: ManOutlined, label: "ManOutlined" },
      {
        name: "medicine-box",
        component: MedicineBoxOutlined,
        label: "MedicineBoxOutlined",
      },
      { name: "menu", component: MenuOutlined, label: "MenuOutlined" },
      {
        name: "merge-cells",
        component: MergeCellsOutlined,
        label: "MergeCellsOutlined",
      },
      {
        name: "money-collect",
        component: MoneyCollectOutlined,
        label: "MoneyCollectOutlined",
      },
      { name: "more", component: MoreOutlined, label: "MoreOutlined" },
      {
        name: "node-expand",
        component: NodeExpandOutlined,
        label: "NodeExpandOutlined",
      },
      {
        name: "node-index",
        component: NodeIndexOutlined,
        label: "NodeIndexOutlined",
      },
      {
        name: "notification",
        component: NotificationOutlined,
        label: "NotificationOutlined",
      },
      { name: "number", component: NumberOutlined, label: "NumberOutlined" },
      {
        name: "one-to-one",
        component: OneToOneOutlined,
        label: "OneToOneOutlined",
      },
      {
        name: "paper-clip",
        component: PaperClipOutlined,
        label: "PaperClipOutlined",
      },
      {
        name: "partition",
        component: PartitionOutlined,
        label: "PartitionOutlined",
      },
      {
        name: "percentage",
        component: PercentageOutlined,
        label: "PercentageOutlined",
      },
    ],
  },
  {
    key: "system",
    title: "系统",
    icons: [
      {
        name: "security-scan",
        component: SecurityScanOutlined,
        label: "安全扫描",
      },
      { name: "lock", component: LockOutlined, label: "锁定" },
      { name: "unlock", component: UnlockOutlined, label: "解锁" },
      { name: "key", component: KeyOutlined, label: "密钥" },
      { name: "safety", component: SafetyOutlined, label: "安全" },
      { name: "tool", component: ToolOutlined, label: "工具" },
      { name: "bug", component: BugOutlined, label: "调试" },
      { name: "reload", component: ReloadOutlined, label: "刷新" },
      { name: "sync", component: SyncOutlined, label: "同步" },
      { name: "loading", component: LoadingOutlined, label: "加载中" },
      { name: "thunderbolt", component: ThunderboltOutlined, label: "闪电" },
      { name: "edit", component: EditOutlined, label: "编辑" },
      { name: "delete", component: DeleteOutlined, label: "删除" },
      { name: "save", component: SaveOutlined, label: "保存" },
      {
        name: "exclamation-circle",
        component: ExclamationCircleOutlined,
        label: "警告",
      },
      { name: "info-circle", component: InfoCircleOutlined, label: "信息" },
      {
        name: "question-circle",
        component: QuestionCircleOutlined,
        label: "帮助",
      },
      { name: "warning", component: WarningOutlined, label: "警告" },
    ],
  },
  {
    key: "communication",
    title: "通信",
    icons: [
      { name: "mail", component: MailOutlined, label: "邮件" },
      { name: "phone", component: PhoneOutlined, label: "电话" },
      { name: "message", component: MessageOutlined, label: "消息" },
      { name: "bell", component: BellOutlined, label: "通知" },
      { name: "send", component: SendOutlined, label: "发送" },
      { name: "inbox", component: InboxOutlined, label: "收件箱" },
      { name: "share-alt", component: ShareAltOutlined, label: "分享" },
      { name: "link", component: LinkOutlined, label: "链接" },
      { name: "global", component: GlobalOutlined, label: "全球" },
      { name: "wifi", component: WifiOutlined, label: "WiFi" },
    ],
  },
  {
    key: "files",
    title: "文件",
    icons: [
      { name: "file", component: FileOutlined, label: "文件" },
      { name: "folder", component: FolderOutlined, label: "文件夹" },
      {
        name: "folder-open",
        component: FolderOpenOutlined,
        label: "打开文件夹",
      },
      { name: "file-text", component: FileTextOutlined, label: "文本文档" },
      { name: "book", component: BookOutlined, label: "书籍" },
      { name: "printer", component: PrinterOutlined, label: "打印" },
      { name: "scan", component: ScanOutlined, label: "扫描" },
      { name: "qrcode", component: QrcodeOutlined, label: "二维码" },
      { name: "download", component: DownloadOutlined, label: "下载" },
      { name: "upload", component: UploadOutlined, label: "上传" },
      { name: "eye", component: EyeOutlined, label: "查看" },
      { name: "eye-invisible", component: EyeInvisibleOutlined, label: "隐藏" },
    ],
  },
  {
    key: "media",
    title: "媒体",
    icons: [
      { name: "camera", component: CameraOutlined, label: "相机" },
      { name: "picture", component: PictureOutlined, label: "图片" },
      { name: "video-camera", component: VideoCameraOutlined, label: "视频" },
      { name: "sound", component: SoundOutlined, label: "声音" },
      { name: "play-circle", component: PlayCircleOutlined, label: "播放" },
      { name: "pause-circle", component: PauseCircleOutlined, label: "暂停" },
      { name: "stop", component: StopOutlined, label: "停止" },
    ],
  },
  {
    key: "device",
    title: "设备",
    icons: [
      { name: "mobile", component: MobileOutlined, label: "手机" },
      { name: "tablet", component: TabletOutlined, label: "平板" },
      { name: "laptop", component: LaptopOutlined, label: "笔记本" },
      { name: "desktop", component: DesktopOutlined, label: "台式机" },
      { name: "credit-card", component: CreditCardOutlined, label: "信用卡" },
      { name: "wallet", component: WalletOutlined, label: "钱包" },
      { name: "bank", component: BankOutlined, label: "银行" },
    ],
  },
  {
    key: "business",
    title: "商业",
    icons: [
      { name: "shop", component: ShopOutlined, label: "商店" },
      { name: "gift", component: GiftOutlined, label: "礼物" },
      { name: "trophy", component: TrophyOutlined, label: "奖杯" },
      { name: "crown", component: CrownOutlined, label: "皇冠" },
      { name: "dollar", component: DollarOutlined, label: "美元" },
      { name: "calculator", component: CalculatorOutlined, label: "计算器" },
      { name: "fund", component: FundOutlined, label: "基金" },
      { name: "pay-circle", component: PayCircleOutlined, label: "支付" },
    ],
  },
  {
    key: "transport",
    title: "交通",
    icons: [
      { name: "car", component: CarOutlined, label: "汽车" },
      { name: "truck", component: TruckOutlined, label: "卡车" },
      { name: "rocket", component: RocketOutlined, label: "火箭" },
    ],
  },
  {
    key: "others",
    title: "其他",
    icons: [
      { name: "heart", component: HeartOutlined, label: "心形" },
      { name: "star", component: StarOutlined, label: "星星" },
      { name: "like", component: LikeOutlined, label: "点赞" },
      { name: "flag", component: FlagOutlined, label: "旗帜" },
      { name: "tag", component: TagOutlined, label: "标签" },
      { name: "tags", component: TagsOutlined, label: "标签组" },
      { name: "environment", component: EnvironmentOutlined, label: "位置" },
      { name: "calendar", component: CalendarOutlined, label: "日历" },
      { name: "clock-circle", component: ClockCircleOutlined, label: "时钟" },
      { name: "bulb", component: BulbOutlined, label: "灯泡" },
      { name: "fire", component: FireOutlined, label: "火焰" },
    ],
  },
];

export interface GenericModalIconSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

// 导出图标映射函数，供其他模块使用
export const getIconMap = (): Record<
  string,
  React.ComponentType<{ style?: React.CSSProperties }>
> => {
  const map: Record<
    string,
    React.ComponentType<{ style?: React.CSSProperties }>
  > = {};
  iconCategories.forEach((category) => {
    category.icons.forEach((icon) => {
      map[icon.name] = icon.component;
    });
  });
  return map;
};

/**
 * 通用图标选择器组件
 * 提供模态框形式的图标选择界面
 */
const GenericModalIconSelect: React.FC<GenericModalIconSelectProps> = ({
  value,
  onChange,
  placeholder = "请选择图标",
  disabled = false,
  style,
  className,
}) => {
  const [visible, setVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  // 获取当前选中的图标信息
  const getSelectedIcon = () => {
    if (!value) {
      return <Text type="secondary">{placeholder}</Text>;
    }

    // 先在图标列表中找到匹配的图标
    for (const category of iconCategories) {
      const icon = category.icons.find((item) => item.name === value);
      if (icon) {
        const IconComponent = icon.component;
        return (
          <Space>
            <IconComponent style={{ fontSize: "16px" }} />
            <Text>{icon.label}</Text>
          </Space>
        );
      }
    }

    // 如果图标不在列表中，至少显示图标名称（支持新图标）
    return (
      <Space>
        <Text type="secondary">图标:</Text>
        <Text>{value}</Text>
      </Space>
    );
  };

  // 处理图标选择
  const handleIconSelect = (iconName: string) => {
    onChange?.(iconName);
    setVisible(false);
  };

  const allCategoryKeys = useMemo(
    () => iconCategories.map((category) => category.key),
    []
  );

  const filteredCategories = useMemo(() => {
    if (!searchText) {
      return iconCategories;
    }
    const lower = searchText.toLowerCase();
    return iconCategories
      .map((category) => ({
        ...category,
        icons: category.icons.filter(
          (icon) =>
            icon.label.toLowerCase().includes(lower) ||
            icon.name.toLowerCase().includes(lower)
        ),
      }))
      .filter((category) => category.icons.length > 0);
  }, [searchText]);

  const [activeKeys, setActiveKeys] = useState<string[]>(allCategoryKeys);

  useEffect(() => {
    const targetKeys = searchText
      ? filteredCategories.map((category) => category.key)
      : allCategoryKeys;
    setActiveKeys((prev) => {
      const isSame =
        prev.length === targetKeys.length &&
        prev.every((key) => targetKeys.includes(key));
      return isSame ? prev : targetKeys;
    });
  }, [searchText, filteredCategories, allCategoryKeys]);

  const columns = 6;

  const handleCollapseChange = (keys: string | string[]) => {
    if (Array.isArray(keys)) {
      setActiveKeys(keys.map((key) => String(key)));
      return;
    }

    if (keys === undefined || keys === null) {
      setActiveKeys([]);
      return;
    }

    setActiveKeys([String(keys)]);
  };

  const collapseItems = filteredCategories.map((category) => ({
    key: category.key,
    label: (
      <Text strong style={{ fontSize: "16px" }}>
        {category.title}
      </Text>
    ),
    children: (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: "8px",
        }}
      >
        {category.icons.map((icon) => {
          const IconComponent = icon.component;
          const isSelected = value === icon.name;

          return (
            <Card
              key={icon.name}
              size="small"
              hoverable
              style={{
                cursor: "pointer",
                border: isSelected ? "2px solid #1890ff" : COMPONENT_OUTLINE_BORDER,
                backgroundColor: isSelected ? "#e6f7ff" : "#fff",
                transition: "all 0.2s",
              }}
              onClick={() => handleIconSelect(icon.name)}
            >
              <div style={{ textAlign: "center", padding: "8px 4px" }}>
                <IconComponent
                  style={{
                    fontSize: "24px",
                    color: isSelected ? "#1890ff" : "#666",
                    marginBottom: "4px",
                    display: "block",
                  }}
                />
                <Text
                  style={{
                    fontSize: "12px",
                    color: isSelected ? "#1890ff" : "#666",
                    display: "block",
                    lineHeight: "1.2",
                  }}
                >
                  {icon.label}
                </Text>
              </div>
            </Card>
          );
        })}
      </div>
    ),
  }));

  return (
    <>
      <Button
        onClick={() => setVisible(true)}
        disabled={disabled}
        style={{
          width: "100%",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "left",
          ...style,
        }}
        className={className}
        type={value ? "default" : "dashed"}
      >
        {getSelectedIcon()}
      </Button>

      <Modal
        title="选择图标"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        width={800}
        style={{ top: 20 }}
        bodyStyle={{ padding: 0 }}
        destroyOnClose
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "70vh",
          }}
        >
          <div style={{ padding: 16 }}>
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
              <Input
                placeholder="搜索图标名称或标签..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                prefix={<SearchOutlined />}
                allowClear
              />
            </Space>
          </div>
          <div style={{ flex: 1, overflowY: "auto", padding: "0 16px 16px" }}>
            {filteredCategories.length > 0 ? (
              <Collapse
                activeKey={activeKeys}
                onChange={handleCollapseChange}
                expandIconPosition="end"
                items={collapseItems}
                bordered={false}
              />
            ) : (
              <div style={{ paddingTop: 32 }}>
                <Empty description="未找到匹配图标" />
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default GenericModalIconSelect;
